export class NotValidIssue extends Error {
  constructor(message: string) {
    super(message);
    this.name = "NotValidIssue";
  }
}
